"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _victory = require("victory");

var _ChartContainer = _interopRequireDefault(require("../ChartContainer"));

var _index = require("../_Themes/index");

var _SimpleLegend = _interopRequireDefault(require("../SimpleLegend"));

var _PieChartLabels = _interopRequireDefault(require("./PieChartLabels"));

var _DataChecker = _interopRequireDefault(require("../utils/DataChecker"));

var _chartHelpers = require("../utils/chartHelpers");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var PieChart = function PieChart(props) {
  var title = props.title,
      subtitle = props.subtitle,
      colors = props.colors,
      data = props.data,
      dataValue = props.dataValue,
      dataLabel = props.dataLabel,
      innerRadius = props.innerRadius,
      loading = props.loading,
      error = props.error,
      halfDoughnut = props.halfDoughnut,
      useLegend = props.useLegend,
      tooltip = props.tooltip,
      width = props.width,
      height = props.height,
      theme = props.theme;
  var safeData = data && data.length ? data : [{}];
  var startAngle = halfDoughnut ? -90 : 0;
  var endAngle = halfDoughnut ? 90 : 360;
  var adjustedHeight = halfDoughnut ? height / 2 : height;
  var legendLabels = safeData.map(function (value) {
    return {
      name: value[dataLabel]
    };
  });
  var legendProps = {};
  var colorScale = colors.length ? colors : theme.group.colorScale;
  var aspectRatio = halfDoughnut ? 650 / 175 : 650 / 350;
  var totalValue = safeData.reduce(function (acc, datum) {
    return acc + datum[dataValue];
  }, 0);

  if (useLegend) {
    legendProps.padding = 25;
  }

  return _react["default"].createElement(_ChartContainer["default"], {
    title: title,
    subtitle: subtitle,
    loading: loading,
    error: error,
    aspectRatio: aspectRatio
  }, _react["default"].createElement(_DataChecker["default"], {
    dataAccessors: {
      dataValue: dataValue
    },
    data: safeData
  }, useLegend && _react["default"].createElement(_SimpleLegend["default"], {
    className: "legend",
    legendData: legendLabels,
    colorScale: colorScale
  }), _react["default"].createElement(_victory.VictoryPie, _extends({
    width: width,
    height: height,
    data: safeData,
    innerRadius: innerRadius,
    colorScale: colorScale,
    theme: theme,
    animate: {
      duration: 1000
    },
    x: dataLabel,
    y: dataValue,
    startAngle: startAngle,
    endAngle: endAngle,
    labelComponent: _react["default"].createElement(_PieChartLabels["default"], {
      dataLabel: dataLabel,
      dataValue: dataValue,
      totalValue: totalValue,
      useLegend: useLegend,
      theme: theme,
      tooltip: tooltip
    }),
    events: tooltip ? (0, _chartHelpers.chartEvents)(theme, true) : null,
    containerComponent: _react["default"].createElement(_victory.VictoryContainer, {
      height: adjustedHeight,
      width: width
    })
  }, legendProps))));
};

PieChart.propTypes = {
  colors: _propTypes["default"].arrayOf(_propTypes["default"].string),
  data: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
  dataLabel: _propTypes["default"].string,
  dataValue: _propTypes["default"].string,
  error: _propTypes["default"].string,
  halfDoughnut: _propTypes["default"].bool,
  height: _propTypes["default"].number,
  innerRadius: _propTypes["default"].number,
  loading: _propTypes["default"].bool,
  subtitle: _propTypes["default"].string,
  title: _propTypes["default"].string,
  useLegend: _propTypes["default"].bool,
  tooltip: _propTypes["default"].bool,
  width: _propTypes["default"].number,
  theme: _propTypes["default"].shape({})
};
PieChart.defaultProps = {
  dataLabel: "x",
  dataValue: "y",
  theme: _index.VictoryTheme,
  colors: [],
  tooltip: true,
  useLegend: false
};
var _default = PieChart;
exports["default"] = _default;